import React from 'react';
import PropTypes from 'prop-types';
import L from 'leaflet';
import { Marker, Popup } from 'react-leaflet';
import globals from '../../../globals/communityGlobals';
import assignmentLocation from '../../../propTypes/entities/assignmentLocation';

const locale = globals.getArea('dailyPlanning');

const AssignmentMarker = ({ assignment, orderMark }) => {
  const icon = L.divIcon({
    className: 'allocateIcons',
    iconSize: [30, 48],
    iconAnchor: [23, 48],
    popupAnchor: [0, -55],
    html: `person_pin_circle<div class='chip'>${orderMark}</div>`,
  });
  const { location, id, title, description, activitiesSummary, activitiesTotalDuration } = assignment;
  const popupContent = (
    <div className="assignment-info">
      {[
        <div key={`assignmentMarkerPopupHeader${id}`}>
          <h5 className="popover-title">
            {title} - {location.name}
          </h5>
          <span className="title-sub">{`${activitiesTotalDuration} ${locale.getMsg('minute')}`}</span>
        </div>,
        <div key={`assignmentMarkerPopupContent${id}`}>
          <div>{activitiesSummary}</div>
          <br />
          <div>{description}</div>
        </div>,
      ]}
    </div>
  );

  return (
    <Marker zIndexOffset={0} icon={icon} position={[location.latitude, location.longitude]}>
      <Popup>{popupContent}</Popup>
    </Marker>
  );
};

AssignmentMarker.propTypes = {
  orderMark: PropTypes.string.isRequired,
  assignment: assignmentLocation.isRequired,
};

export default AssignmentMarker;
